<template>
	<div class="catch-phrase">
        <div class="container-fluid p-0" style="background-color: none !important;">
			<b-tabs card class="nonobg">
				<b-tab title="Home" class="nobg">
					<div class="container-fuild test py-0 mx-0 mx-lg-0">
						<NewsBox :secondBoxMessages="secondBoxMessages" 
							:userPowers="userPowers"
							@secondBoxMessagesChanged="changeSecond"
						/>
                    </div>
                </b-tab>
				<b-tab title="Aktualizace" class="nobg">
					<div class="container-fuild test py-0 mx-0 mx-lg-0">
                        <FeaturesBox :firstBoxMessages="firstBoxMessages"
                           :userName="userName" 
                            @firstBoxMessagesChanged="changeFirst"
                        />
                    </div>
                </b-tab>
				<b-tab title="Produkty" class="nobg">
					<div class="container-fuild test py-0 mx-0 mx-lg-0">
						<StatsBox :thirdBoxStats="thirdBoxStats" />
                    </div>
                </b-tab>
            </b-tabs>
        </div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
import StatsBox from '@/components/info_boxes/StatsBox'
import FeaturesBox from '@/components/info_boxes/FeaturesBox'
import NewsBox from '@/components/info_boxes/NewsBox'

export default {
    name: 'CatchPhrase',
    props: {
        userName: String,
        userPowers: Array,
    },

    components: {
        StatsBox,
        FeaturesBox,
        NewsBox,
    },

    data() {
        return {
            firstBoxMessages: [],
            secondBoxMessages: [],
            thirdBoxStats: [],
            newMessage: '',
            newMessageZprava: '',
        }
    },

    async mounted () {
        const fetchFirstBoxMessages = await AdditionsService.fetchFeatureMessages()
        this.firstBoxMessages = fetchFirstBoxMessages.data.msgs

        const fetchSecondBoxMessages = await AdditionsService.fetchZpravyMessages()
        this.secondBoxMessages = fetchSecondBoxMessages.data.msgs

        const fetchThirdBoxStats = await AdditionsService.fetchStats()
        this.thirdBoxStats = fetchThirdBoxStats.data.statsSorted
    },

    methods: {
        changeFirst (to) {
            this.firstBoxMessages = to
        },

        changeSecond (to) {
            this.secondBoxMessages = to
        },
    }
}
</script>

<style lang="stylus" scoped>
.catch-phrase 
    display flex
    flex-direction column
    color black

.reporting 
    display flex
    flex-direction row

@media (max-width 1000px) 
    .reporting 
        flex-direction column

</style>



// WEBPACK FOOTER //
// src/views/CatchPhrase.vue